module.exports = __webpack_public_path__ + "static/media/20170806_10day_0408AT.672c04c7.jpg";